import React from 'react';
import classes from './PaginationPageNumbers.module.css';

const PaginationPageNumbers = ({ pageSlots, currentPage, onPageSelect }) => (
  
  <div className={classes.wrapper}>
    {pageSlots.map((p, i) =>
      p !== null ? 
        <button key={p} type="button" className={`${classes.pageBtn} ${p === currentPage ? classes.pageBtnActive : ''}`} onClick={() => onPageSelect(p)}>
          <span className={classes.pageBtnText}>{p}</span>
        </button>
      : 
        <span key={`empty-${i}`} className={classes.placeholder} aria-hidden />
    )
    }
  </div>
);

export default PaginationPageNumbers;
